export const modifyTitle = (
  title: string,
  learnersDataLength: number
): string => {
  const words = title?.split(" ");
  const lastWord = words?.pop();

  if (!lastWord) return title;

  const isPlural = lastWord?.endsWith("s");

  let modifiedLastWord;
  if (learnersDataLength > 1) {
    modifiedLastWord = isPlural ? lastWord : lastWord + "s";
  } else {
    modifiedLastWord = isPlural ? lastWord?.slice(0, -1) : lastWord;
  }

  return [...words, modifiedLastWord].join(" ");
};
